import React, { useState } from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { useTranslation } from '@application/Interfaces/Hooks/useTranslation'
import { ArrowIcon } from '@application/Interfaces/Icons'
import { TransformProps } from '@application/Interfaces/Icons/types'
import { CategoryType } from '@src/Application/Types/ComponentTypes'

import { Category, CategoryListExpandableWrapper, CategoryTitle, ImageWrapper } from './CategoryList.styled'
import { getArrowDirection, toggleMenu } from './utils'

type Props = {
    categories: CategoryType[]
    label: string
}

export const CategoryListExpandable = ({ categories, label }: Props): JSX.Element => {
    const { t } = useTranslation()
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
        <CategoryListExpandableWrapper onClick={toggleMenu({ isMenuOpen, setIsMenuOpen })} $open={isMenuOpen}>
            <CategoryTitle>
                {t(label)}{' '}
                <ArrowIcon
                    direction={getArrowDirection(isMenuOpen) as TransformProps}
                    colorCode="g500"
                    width={18}
                    height={9}
                />
            </CategoryTitle>
            {categories.map((category, i) => (
                <Category to={category.categoryUrl} key={`category-item-mobile-${category.categoryUrl}`}>
                    {category.image && (
                        <ImageWrapper>
                            <Image image={category.image} imageAnimation={category.imageAnimation} />
                        </ImageWrapper>
                    )}
                    {category.title}
                </Category>
            ))}
        </CategoryListExpandableWrapper>
    )
}
